import { api } from 'helpers/Api';
import { toDate } from 'helpers/Format';
export default class {
    salesReport(range) {
        let salesReport;
        let today = new Date();
        return api.get(`/invoice/totalsale/${range}`).then(totalSales => {
            let salesArray = totalSales.map(sales => sales.sales);
            salesArray.unshift(0);
            if (totalSales.length > 3) {
                salesReport = {
                    saleDate: toDate(totalSales[0].saleDate),
                    sales: salesArray
                };
            }
            else {
                salesReport = {
                    saleDate: toDate(new Date()),
                    sales: totalSales.length > 0 ? salesArray : salesArray.unshift(0)
                };
            }
            return salesReport;
        });
    }
    customerReport(range) {
        return api.get(`/invoice/salescustomers/${range}`).then(totals => totals);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Dashboard/Store.ts
// module id = 342
// module chunks = 0